import React, { Component,useState,useEffect } from 'react';
import { Link,useLocation,useParams } from "react-router-dom";
import { getBusiness } from '../../Services/business.service';
import {getReviews} from '../../Services/reviews.service';
import StarRatings from 'react-star-ratings';
import b1 from "../../assets/images/b1.jpg"
import profile1 from "../../assets/images/profile1.jpg"
import classes from "./BusinessDescription.module.css"



export const BusinessDescription=()=>{
    const {id} = useParams();
    //console.log("Id of the selected item is :",id);
    //const location = useLocation();
    //console.log('Sample data object is : ',location.state.data);
    const [perviusData,setperviusData] = useState();
    const [currentBusinessReview,setcurrentBusinessReview] = useState();
    useEffect(()=>{
        setperviusData();
        getBusiness().then((res)=>{
            //setperviusData(res);
            // Fetching business data
            for(let i=0;i<res.length;i++)
            {
                // console.log('Business is found at position ',res[i].businessId);
                if(res[i].businessId===id)
                {
                   
                    setperviusData(res[i]); 
                    console.log('Business is found at position ',res[i]);

                }
                    
                }
                console.log('Business is found at position ',id);
            console.log(res.length);

            //Fetching the reviews
            getReviews().then((res)=>{
                let review = [];
                for(let i=0; i<res.length;i++)
                {
                    if(res[i].itemId===id)
                    {
                        console.log('Reviews for the current item is : ',res[i]) 
                        review.push(res[i]);
                        // currentBusinessReview(...currentBusinessReview,res[i]);       
                    }
                }
                console.log('Specific Business review  are :',review);
                setcurrentBusinessReview(review);
                console.log('Reviews are ',res)}
                );
           // console.log('business Array on Discription page is',res[0].businessId);
           // console.log('id of the budiness is : ',id);
            

        });        
        // let sample = location.state.data;
        //setperviusData(sample);
        // console.log('Data from the previous page is : ',location.state.data);

    },[]);
    return(
        <>
        {
          typeof perviusData === 'undefined'?<h1>Fetching Data....</h1>:
          <div className="descriptionPage">
            {/* banner */}
            <div className={classes.descBanner}>
                <div className={classes.imgDiv}>
                    <img src={perviusData.coverPhotoURL} alt="banner" />
                </div>
                <div className={classes.descBannerContent}>
                    <div className="container">
                    {console.log('previous data is :',perviusData) }
                    <h1>{perviusData.name}</h1>
                    <div className={classes.reviewDiv}>
                        <StarRatings
                        rating={perviusData.businessCount%5}
                        starDimension="18px"
                        starSpacing="1px"
                        numberOfStars={5}
                        starRatedColor="orange"
                        />
                        <span className={classes.reviewSpan}>(1 Review)</span>
                    </div>
                    <div className={classes.descBannerLinkContainer}>
                        <div className={classes.descBannerLink}>
                            <div className="mr-4 mb-2">
                                <i className="fa fa-map-marker mr-2"></i>
                                <span>{perviusData.address}</span>
                            </div>
                            <div className="mr-4 mb-2">
                                <i className="fa fa-phone mr-2"></i>
                                <span><a href="tel:92123456">{perviusData.phoneNumber}</a></span>
                            </div>
                            <div className="mr-4 mb-2">
                                <i className="fa fa-envelope-open mr-2"></i>
                                <span><a href="mailto:someone@example.com">{perviusData.website}</a></span>
                            </div>
                        </div>
                        <div className={classes.writeReviewDiv}>
                            <Link className={classes.WriteRevBtn} to={`/rate/${id}`}>Write Review</Link>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        {/* description */}
            <section className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className={classes.descDiv}>
                        <p>About Business : {perviusData.description}</p>
                            
                        </div>
                        <div className={classes.review}>
                            {/* rewiew div */}
                            {
                              typeof currentBusinessReview === 'undefined'?<h1>Fetching reviews</h1>:
                              currentBusinessReview.length===0?<h1>No review found for this business</h1>:
                              currentBusinessReview.map((item,index)=>
                              
                              <div key={index} className={classes.reviewContent} >
                              {
                                item.status?<>
                                <h3 className="mb-4">
                                 Review</h3>
                                <div className="row">
                                    <div className="col-auto">
                                        <div className={classes.reviewerLogo}>
                                            <img src={item.url} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex  jc-sb">
                                            <h5 className="mb-0">{item.reviewTitle}</h5>
                                            <div className='d-none'><span>5</span><span> minutes</span><span> ago</span></div>
                                        </div>
                                        <div className="mb-3">
                                            <StarRatings
                                            rating={item.myRating}
                                            starDimension="18px"
                                            starSpacing="1px"
                                            numberOfStars={5}
                                            starRatedColor="orange"
                                            />
                                        </div>
                                        <div>
                                            <p>{item.discripton}</p>
                                        </div>
                                    </div>
                                </div>
                                </>:<></>
                                }
                                
                            </div>
                            
                               
                               )    
                            }                      
                          </div>
                    </div>
                    <div className="col-lg-4">
                        <div className={classes.descDiv}>
                            <div>
                                <h4><i class="fa fa-clock-o" aria-hidden="true"></i> Openening Hours</h4>
                                {
                                    perviusData.businessHours.map((item,index)=> 
                                      <div className="d-flex jc-sb py-2 colorGray" key={index}>
                                          <div>{item.days} </div>
                                          <div className=""><span>{item.from}</span>- <span>{item.to}</span></div>
                                      </div>
                                     )
                                }
                           </div>
                        </div>    
                        <div className={classes.descDiv}>
                            {/* contact div */}
                            <div>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.136308596205!2d-73.95546658463427!3d40.737026079329276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2593bf402b47b%3A0x610dbb75dd8f06a4!2s111%20Clay%20St%2C%20Brooklyn%2C%20NY%2011222%2C%20USA!5e0!3m2!1sen!2s!4v1630986222865!5m2!1sen!2s" width="100%" height="300"  allowfullscreen="" loading="lazy"></iframe>
                            </div>
                            <div className={classes.descInnerDiv}>
                                <div className="colorGray border-bottom-light py-3">
                                    <i className="fa fa-map-marker mr-2 iconColor "></i>
                                    <span>{perviusData.address}</span>
                                </div>
                                <div className="colorGray border-bottom-light py-3">
                                    <i className="fa fa-phone mr-2 iconColor "></i>
                                    <span><a href="tel:92123456">{perviusData.phoneNumber}</a></span>
                                </div>
                                <div className="colorGray border-bottom-light py-3">
                                    <i className="fa fa-envelope-open mr-2 iconColor "></i>
                                    <span><a href="mailto:someone@example.com">{perviusData.website}</a></span>
                                </div>
                                <div className={classes.socialIcon}>
                                    <a href="#"><i class="fa fa-facebook fbIconColor mr-4" aria-hidden="true"></i></a>
                                    <a href="#"><i class="fa fa-twitter twitterIconColor mr-4" aria-hidden="true"></i></a>
                                    <a href="#"><i class="fa fa-linkedin  inIconColor mr-4" aria-hidden="true"></i></a>
                                    <a href="#"><i class="fa fa-instagram  instaIconColor mr-4" aria-hidden="true"></i></a>
                                </div>
                            </div>

                        </div>
                   
                    </div>
                </div>
            </section>
        </div>
        }
        </>
    )
}